export const sinElSistema: string[] = [
  'Jornadas eternas sin ganar lo suficiente',
  'Clientas demandantes que te roban horas y energía',
  'No tener diseños listos y perder tiempo pensando cada uno',
  'No saber cuánto cuesta realmente cada servicio',
  'Clientas baratas que no valoran tu trabajo',
  'Errores que generan reclamos y estrés mental',
  'Terminás el día agotada y con menos dinero del que esperabas',
]

export const conElSistema: string[] = [
  'Jornadas ordenadas, con tiempos reales por servicio',
  'Límites claros con protocolos que evitan abusos y reclamos',
  'Diseños listos para mostrar y cobrar según complejidad',
  'Costos y precios calculados con matriz adaptada a tu país',
  'Clientas premium que valoran y pagan tu trabajo',
  'Soluciones documentadas para resolver imprevistos sin pánico',
  'Cerrás el día con más clientas atendidas y mejor ganancia',
]

export const esParaVos: string[] = [
  'Sos manicurista, técnica de uñas o dueña de estética en actividad',
  'Querés trabajar con más orden, criterio y seguridad',
  'Buscás un sistema listo para usar, no más contenido para procesar',
  'Querés cobrar lo que corresponde sin perder clientas',
  'Trabajás desde casa, en salón o en estética propia',
  'Querés que tu servicio se vea y se sienta más profesional',
]

export const noEsParaVos: string[] = [
  'Buscás un curso con clases en video o certificación académica',
  'Esperás que alguien te diga exactamente qué decirle a cada clienta',
  'No estás dispuesta a invertir en organizar y mejorar tu trabajo',
  'Querés resultados sin aplicar ningún cambio en tu día a día',
]
